import type { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';
import { FileText } from 'lucide-react';

type PortalEmptyStateProps = {
  icon?: LucideIcon;
  title: string;
  description: string;
  action?: ReactNode;
};

export function PortalEmptyState({
  icon: Icon = FileText,
  title,
  description,
  action,
}: PortalEmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-12 text-center">
      <Icon className="text-muted-foreground mb-4 h-12 w-12" aria-hidden="true" />
      <h2 className="text-foreground mb-2 text-lg font-semibold">{title}</h2>
      <p className="text-muted-foreground mb-4 max-w-md text-sm">{description}</p>
      {action}
    </div>
  );
}
